import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientEHRService = {
  getPatientEHRPrescriptions(params: any){ return axiosRequest('GET', API_PATH.PATIENT_EHR.PRESCRIPTION(params)) },
  getPatientSummary(data: any){ return axiosRequest('POST', API_PATH.PATIENT_EHR.GET_LAST, data) },
  getPatientEHRVisit(data: any){ return axiosRequest('POST', API_PATH.PATIENT_EHR.VISIT, data) },
  getPatientEHRAppointments(data: any){ return axiosRequest('POST', API_PATH.PATIENT_EHR.APPOINTMENT, data) },
}